import React, { useState, useEffect } from 'react';
import { MainComponent, Texts, Component1, Component2, InnerComponent, Component4, Component3, HiddenComponent, FooterPart, HeaderPart } from '../style.js';
import InputSelect from 'src/components/shared/Form/Select/index.js';
import { useTheme } from '@emotion/react';
import InputComponent from 'src/components/shared/Form/Input/index.js';
import theme, { palette, shadows } from 'src/config/theme.js';
import { alpha, Box } from '@mui/material';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { postStaffRequest } from '../../../store/appActions.js';

import ButtonComponent from 'src/components/shared/Button/index.js';
import { ReactComponent as CloseIcon } from '../../../../../assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../assets/images/add-square.svg';
import { getUserFromToken } from 'src/DecodeToken.js';

import { SaveButton } from '../style.js';
import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive.js';


const roleData = [
    { label: 'Nurse', value: 'nurse' },
    { label: 'Assistant', value: 'assistant' },
    { label: 'Receptionist', value: 'receptionist' },
]
const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    contactNo: Yup.string().required('Contact No is required').matches(/^\d{10}$/, 'Contact number must be exactly 10 digits'),
    email: Yup.string().required('Email is required'),
    password: Yup.string().required('Password must be required'),
    role: Yup.string().required('Select Your Role'),
})
function AddStaff({ onClose, updateStaff }) {
    const { isMobile, isTablet } = useResponsive();
    const theme = useTheme();
    const [patients, setPatients] = useState([]);
    const clinicData = useSelector((state) => state.app.clinics);
    const clinicId = clinicData?.clinicId;
    const dispatch = useDispatch();

    const handleSubmit = async (values, { resetForm }) => {
        const userId = getUserFromToken();
        console.log("my user id here", userId)
        if (!userId) {
            console('Failed to identify user. Please login again.', { variant: 'error' });
            return;
        }
        try {

            const staffData = {
                name: values.name,
                contactNo: values.contactNo,
                role: values.role,
                email: values.email,
                password: values.password,
                clinic: clinicId,
                user: userId,
            }

            const response = await new Promise((resolve, reject) => {
                dispatch(postStaffRequest(staffData, resolve, reject));
            });
            console.log(`Staff created successfully ${response}`)

            updateStaff();
            toast.success(response.message)

            resetForm();
            onClose();
        } catch (error) {
            console.log(error.message || 'Failed to add Staff', { variant: 'error' });
        }
    };
    return (
        <Formik
            initialValues={{
                name: '',
                contactNo: '',
                email: '',
                password: '',
                role: '',


            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}

        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <Form >
                    <>
                        <HeaderPart>
                            Add Staff
                            <CloseIcon width={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <MainComponent>
                            <HiddenComponent>
                                <InnerComponent>
                                    <Texts>New Staff Name</Texts>
                                    <InputComponent
                                        name="name"
                                        variant="outlined"
                                        placeholder="Enter Name"
                                        fullWidth
                                        value={values.name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.name && Boolean(errors.name)}
                                        helperText={touched.name && errors.name}
                                        sx={{
                                            backgroundColor: palette.gery.white,
                                            boxShadow: shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                padding: '10px 0px',
                                                borderRadius: '12px',
                                                height: '52px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                            },
                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                            },
                                        }}
                                    />
                                </InnerComponent>
                                <InnerComponent>
                                    <Texts>Phone Number</Texts>
                                    <InputComponent
                                        name="contactNo"
                                        variant="outlined"
                                        placeholder="Enter Number"
                                        fullWidth
                                        value={values.contactNo}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.contactNo && Boolean(errors.contactNo)}
                                        helperText={touched.contactNo && errors.contactNo}
                                        sx={{
                                            backgroundColor: palette.gery.white,
                                            boxShadow: shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                padding: '10px 0px',
                                                borderRadius: '12px',
                                                // border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                // alignItems: 'flex-start',
                                                height: '52px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                            },
                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                            },
                                        }}
                                    />


                                </InnerComponent>
                            </HiddenComponent>
                            <Component2>
                                <InnerComponent sx={{ width: '100%' }}>
                                    <Texts>Role</Texts>
                                    <InputSelect
                                        name="role"
                                        showNone={false}
                                        options={roleData}
                                        value={values.role}
                                        onChange={(value) => setFieldValue('role', value)}
                                        onBlur={handleBlur}
                                        error={touched.role && Boolean(errors.role)}
                                        helperText={touched.role && errors.role}
                                        variant="outlined"
                                        placeholder="Select"
                                        fullWidth
                                        sx={{
                                            // width: '200px',
                                            boxShadow: theme.shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                height: '52px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                borderRadius: '12px',
                                            },
                                        }}
                                    />

                                </InnerComponent>
                            </Component2>
                            <Component2>
                                <InnerComponent sx={{ width: '100%' }}>
                                    <Texts>Email</Texts>
                                    <InputComponent
                                        name="email"
                                        variant="outlined"
                                        placeholder="Enter email"
                                        fullWidth
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.email && Boolean(errors.email)}
                                        helperText={touched.email && errors.email}
                                        sx={{
                                            backgroundColor: palette.gery.white,
                                            boxShadow: shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                padding: '10px 0px',
                                                borderRadius: '12px',
                                                height: '52px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                            },
                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                            },
                                        }}
                                    />
                                </InnerComponent>

                            </Component2>
                            <Component2>
                                <InnerComponent sx={{ width: '100%' }}>
                                    <Texts>Password</Texts>
                                    <InputComponent
                                        name="password"
                                        variant="outlined"
                                        placeholder="Enter Password"
                                        fullWidth
                                        value={values.password}
                                        type="password"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.password && Boolean(errors.password)}
                                        helperText={touched.password && errors.password}
                                        sx={{
                                            backgroundColor: palette.gery.white,
                                            boxShadow: shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                padding: '10px 0px',
                                                borderRadius: '12px',
                                                height: '52px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                            },
                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                            },
                                        }}
                                    />
                                </InnerComponent>
                            </Component2>

                        </MainComponent>
                        <FooterPart >
                            <ButtonComponent
                                variant="none"
                                startIcon={<CloseIcon
                                    width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
                                onClick={onClose}
                            >
                                Cancel
                            </ButtonComponent>
                            <SaveButton
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon
                                    width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24}
                                    sx={{ color: theme.palette.primary.main }} />}
                            >Save</SaveButton>
                        </FooterPart>
                    </>
                </Form>

            )}
        </Formik>
    )
}

export default AddStaff;



